module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"slate__check__availability\" class=\"slate\">\n    <div class=\"slate__wrapper\">\n        <div class=\"slate__title\">")
    ; __append(escapeFn( title ))
    ; __append("</div>\n        <div class=\"slate__description\">\n            <p>")
    ; __append(escapeFn( desc ))
    ; __append("</p>\n\n            <div class=\"slate__loading__animation\">\n                <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\" class=\"icon__loading__svg\">\n                    <g style=\"fill: rgba( 255, 255, 255, 0.8 ) !important;\">\n                        <path d=\"M8.16,138.48A99.6,99.6,0,0,0,49,185.78l5.8-14.07a84.94,84.94,0,0,1-.27-143.23l-5.83-14A100.06,100.06,0,0,0,8.16,138.48Z\"></path>\n                        <path d=\"M199.54,85.9A100.13,100.13,0,0,0,76.29,3l5.83,14A85,85,0,0,1,184.38,85.9Z\"></path>\n                        <path d=\"M138.94,192.39a100,100,0,0,0,60.34-76.6H184.07A84.86,84.86,0,0,1,82.43,183.1l-5.8,14.07A99.6,99.6,0,0,0,138.94,192.39Z\"></path>\n                    </g>\n                </svg>\n            </div>\n\n            <div class=\"slate__faq\">\n                <p>")
    ; __append( faqMessage )
    ; __append(" \n                </p>\n            </div>\n        </div>\n    </div>\n</div>")
  }
  return __output;

}